module.exports = __webpack_public_path__ + "static/media/users.fd95954b.svg";